import type { JSX } from "preact";

interface Step {
  label: string;
}

interface Props {
  steps: Step[];
  activeIndex: number;
}

export function Stepper({ steps, activeIndex }: Props) {
  const nodes: JSX.Element[] = [];
  steps.forEach((step, i) => {
    const status: "done" | "active" | "pending" =
      i < activeIndex ? "done" : i === activeIndex ? "active" : "pending";
    const stepCls = `tl-stepper__step tl-stepper__step--${status}`;
    nodes.push(
      <div key={`s${i}`} class={stepCls}>
        <div class="tl-stepper__circle">
          {status === "done" ? (
            <span class="material-icons" aria-hidden="true">
              check
            </span>
          ) : (
            <span>{i + 1}</span>
          )}
        </div>
        <span class="tl-stepper__label">{step.label}</span>
      </div>
    );
    if (i < steps.length - 1) {
      const connCls =
        "tl-stepper__connector" +
        (i < activeIndex ? " tl-stepper__connector--done" : "");
      nodes.push(<div key={`c${i}`} class={connCls} />);
    }
  });
  return <div class="tl-stepper">{nodes}</div>;
}
